/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S6_P1Inputs */

const en_guide_json_schema_s6_p1 = /** @type {(inputs: Guide_Json_Schema_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema earns its keep at the boundaries of a system, where data you do not control arrives. Validating an incoming request, a config file, or a third-party webhook against a schema turns a vague runtime failure into a precise, early error that names the field at fault.`)
};

const ko_guide_json_schema_s6_p1 = /** @type {(inputs: Guide_Json_Schema_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema는 통제할 수 없는 데이터가 들어오는 시스템의 경계에서 제값을 합니다. 들어오는 요청, 설정 파일, 외부 웹훅을 스키마로 검증하면 모호한 런타임 실패가 어느 필드가 문제인지 짚어 주는 정확하고 이른 오류로 바뀝니다.`)
};

const ja_guide_json_schema_s6_p1 = /** @type {(inputs: Guide_Json_Schema_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema は、自分で制御できないデータが入ってくるシステムの境界で真価を発揮します。入ってくるリクエスト、設定ファイル、第三者の Webhook をスキーマで検証すると、あいまいな実行時の失敗が、どのフィールドが原因かを示す正確で早いエラーに変わります。`)
};

/**
* | output |
* | --- |
* | "JSON Schema earns its keep at the boundaries of a system, where data you do not control arrives. Validating an incoming request, a config file, or a third-pa..." |
*
* @param {Guide_Json_Schema_S6_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s6_p1 = /** @type {((inputs?: Guide_Json_Schema_S6_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S6_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s6_p1(inputs)
	if (locale === "ko") return ko_guide_json_schema_s6_p1(inputs)
	return ja_guide_json_schema_s6_p1(inputs)
});